export default __webpack_public_path__ + "static/logo-6e76dd9823cc41ae8d3a7f37e06bd31b.png";